// Schedule/timeclock date helpers extracted from app.jsx (decomposition).
import { ymdLocal } from './format.js';

// Normalize a location display name into a stable key ("JT Connell" → "jt_connell").
export function locationKeyFromName(name) {
  if (!name) return null;
  return name.toLowerCase().replace(/\s+/g, '_');
}

// YYYY-MM-DD of the Monday that starts the ISO week containing `date`, in tz.
export function isoMondayOf(date, tz = 'America/New_York') {
  const ymd = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
  const d = new Date(ymd + 'T12:00:00Z');
  // ISO weeks: Mon=1..Sun=7. Date.getUTCDay returns Sun=0..Sat=6 — convert.
  const dow = d.getUTCDay() === 0 ? 7 : d.getUTCDay();
  d.setUTCDate(d.getUTCDate() - (dow - 1));
  return ymdLocal(d);
}
